export const AVAILABILITY_TIME_FILTER = {
    anyTime: 0,
    before10AM: 1,
    after5PM: 2,
    before10AMOrAfter5PM: 3,
};

/**
 * Returns the time filter enum corresponding to the provided filters
 */
export const getAvailabilityTimeFilter = (showTimesBefore10, showTimesAfter5) => {
    if (showTimesBefore10 && showTimesAfter5) {
        return AVAILABILITY_TIME_FILTER.before10AMOrAfter5PM;
    } else if (showTimesBefore10) {
        return AVAILABILITY_TIME_FILTER.before10AM;
    } else if (showTimesAfter5) {
        return AVAILABILITY_TIME_FILTER.after5PM;
    } else {
        return AVAILABILITY_TIME_FILTER.anyTime;
    }
};

export const getAvailabilityTimeFilterForFacetedSearch = (appliedFilters, facets) => {
    const specialHoursFacet = facets.find(facet => facet.facetId === 'special_hours');
    const specialHoursFilter = appliedFilters.special_hours;
    if (specialHoursFacet && specialHoursFilter) {
        const timesBefore10Option = specialHoursFacet.options.find(({ displayName }) => displayName === 'Before 10:00 AM');
        const timesAfter5Option = specialHoursFacet.options.find(({ displayName }) => displayName === 'After 5:00 PM');
        const showTimesBefore10 = timesBefore10Option && specialHoursFilter.includes(timesBefore10Option.optionId);
        const showTimesAfter5 = timesAfter5Option && specialHoursFilter.includes(timesAfter5Option.optionId);
        return getAvailabilityTimeFilter(showTimesBefore10, showTimesAfter5);
    } else {
        return AVAILABILITY_TIME_FILTER.anyTime;
    }
};
